/** Person referenced as an owner or contact. */
export interface ContactData {
  userId: string;
  email: string;
}

/** Cloud provider and region for a deployment. */
export interface CloudDeployment {
  cloudProvider: string;
  cloudRegion: string;
}

/**
 * Enum for Access Request Status
 */
export enum AccessRequestStatus {
  Pending = 'Pending',
  Provisioning = 'Provisioning',
  Approved = 'Approved',
  Rejected = 'Rejected',
  Revoked = 'Revoked',
  Unsubscribed = 'Unsubscribed',
}

/**
 * Enum for the agent provider's decision status on an access renewal entry
 */
export enum AccessReviewStatus {
  Completed = 'Completed',
  Pending = 'Pending',
  Ongoing = 'Ongoing',
}

/** Lifecycle states of an entity onboarding record. */
export enum OnboardingStatus {
  Draft = 'Draft',
  Provisioning = 'Provisioning',
  Published = 'Published',
  Failed = 'Failed',
}
